import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.jpeg';

const Header = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  const publicNavItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/products', label: 'Products' },
    { path: '/plans', label: 'Our Plans' },
    { path: '/contact', label: 'Contact' },
  ];

  const authNavItems = [
    { path: '/dashboard', label: 'Dashboard' },
    // { path: '/admin', label: 'Admin' },
  ];

  const adminNavItems = [
    { path: '/admin', label: 'Admin Panel' },
    // { path: '/admin/users', label: 'Users' },
    // { path: '/admin/products', label: 'Products' },
    // { path: '/admin/payouts', label: 'Payouts' },
    // { path: '/admin/reports', label: 'Reports' },
  ];

  const currentNavItems = isAuthenticated
    ? (user?.mySponsorCode === 'DMC99999' ? [...authNavItems, ...adminNavItems] : authNavItems)
    : publicNavItems;

  return (
    <header className="sticky top-0 z-50">
      {/* Top Bar - Primary Blue with subtle pattern */}
      {/* <div className="bg-[#0F2F3D] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute -left-4 -top-4 w-24 h-24 rounded-full bg-white"></div>
          <div className="absolute -right-4 -bottom-4 w-32 h-32 rounded-full bg-white"></div>
        </div>
        <div className="max-w-7xl mx-auto px-5 py-2.5 relative">
          <div className="flex flex-wrap justify-between items-center text-sm">
            <div className="flex items-center divide-x divide-white/20">
              <div className="flex items-center pr-4">
                <span className="font-medium">+91-XXXXXXXXXX</span>
              </div>
              <div className="flex items-center pl-4">
                <span className="font-medium">info@desimart.com</span>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <span className="bg-[#F47C4D] px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-lg">
                MSME REGISTERED
              </span>
              <span className="text-white/80 text-xs hidden sm:inline font-medium">
                Government of India
              </span>
            </div>
          </div>
        </div>
      </div> */}

      {/* Main Navigation */}
      <nav className="bg-white/95 backdrop-blur-md shadow-lg">
        <div className="max-w-7xl mx-auto px-5">
          <div className="flex justify-between items-center py-4">
            {/* Logo with enhanced styling */}
            <Link to="/" className="flex items-center space-x-4 group">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] rounded-lg blur-md opacity-0 group-hover:opacity-70 transition-opacity"></div>
                <img
                  src={logo}
                  alt="DESi MART"
                  className="relative w-16 h-16 object-contain rounded-lg shadow-md group-hover:shadow-xl transition-all duration-300 group-hover:scale-105"
                />
              </div>
              <div className="relative inline-block group">

                {/* Brand Name */}
                <h1 className="text-3xl sm:text-4xl font-extrabold tracking-wide bg-gradient-to-r from-[#E4572E] via-[#FF8A5B] to-[#F47C4D] bg-clip-text text-transparent drop-shadow-sm">
                  DESi MART
                </h1>

                {/* Animated Dot */}
                <span className="absolute -top-1 -right-5 w-3 h-3 bg-[#E4572E] rounded-full shadow-lg shadow-[#E4572E]/50 animate-pulse"></span>

                {/* Tagline */}
                <p className="text-sm font-semibold text-red-600 tracking-widest mt-1 group-hover:text-[#E4572E] transition duration-300">
                  Karlo Sapne Mutthi Me
                </p>

                {/* Underline Effect */}
                <div className="h-[2px] w-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] mt-1 group-hover:w-full transition-all duration-500"></div>

              </div>
            </Link>

            {/* Desktop Navigation - No Icons */}
            <div className="hidden lg:flex items-center space-x-1">
              {currentNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`relative px-4 py-2.5 rounded-lg font-medium text-sm tracking-wide transition-all duration-300 ${isActivePath(item.path)
                    ? 'text-white'
                    : 'text-[#333333] hover:text-[#E4572E]'
                    }`}
                  style={isActivePath(item.path) ? { backgroundColor: '#0F2F3D' } : {}}
                >
                  <span className="relative z-10">{item.label}</span>
                  {!isActivePath(item.path) && (
                    <span className="absolute inset-0 rounded-lg bg-[#F2F2F2] scale-0 hover:scale-100 transition-transform duration-300 -z-0"></span>
                  )}
                  {item.badge > 0 && (
                    <span className="absolute -top-1 -right-1 bg-[#E4572E] text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1.5 shadow-lg animate-pulse">
                      {item.badge}
                    </span>
                  )}
                </Link>
              ))}

              {/* User Actions */}
              {isAuthenticated ? (
                <div className="flex items-center space-x-4 ml-6 pl-6 border-l-2 border-[#F2F2F2]">
                  <div className="flex items-center space-x-3">
                    <div className="relative">
                      <div className="absolute inset-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] rounded-full blur-sm opacity-70"></div>
                      <div
                        className="relative w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-xl"
                        style={{ background: 'linear-gradient(135deg, #0F2F3D 0%, #E4572E 100%)' }}
                      >
                        {user?.name?.charAt(0)?.toUpperCase()}
                      </div>
                    </div>
                    <div className="hidden xl:block">
                      <p className="text-sm font-bold" style={{ color: '#333333' }}>{user?.name}</p>
                      {/* <p className="text-xs font-medium" style={{ color: '#E4572E' }}>{user?.rank || 'Premium Member'}</p> */}
                    </div>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="px-5 py-2.5 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 font-medium text-sm tracking-wide"
                  >
                    Sign Out
                  </button>
                </div>
              ) : (
                <div className="flex items-center space-x-3 ml-6 pl-6 border-l-2 border-[#F2F2F2]">
                  <Link
                    to="/login"
                    className="px-5 py-2.5 border-2 border-[#0F2F3D] text-[#0F2F3D] rounded-lg hover:bg-[#0F2F3D] hover:text-white transition-all duration-300 font-medium text-sm tracking-wide"
                  >
                    Sign In
                  </Link>
                  <Link
                    to="/register"
                    className="px-5 py-2.5 bg-[#0F2F3D] text-white rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 font-medium text-sm tracking-wide relative overflow-hidden group"
                  >
                    <span className="relative z-10">Join Free</span>
                    <span className="absolute inset-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  </Link>
                </div>
              )}
            </div>

            {/* Mobile Menu Button - Enhanced */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden relative w-12 h-12 rounded-lg bg-[#F2F2F2] hover:bg-[#E4572E] group transition-all duration-300"
              aria-label="Toggle menu"
            >
              <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-[#E4572E] to-[#F47C4D] opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="relative flex flex-col items-center justify-center space-y-1.5">
                <div className={`w-5 h-0.5 bg-[#0F2F3D] group-hover:bg-white transition-all duration-300 ${isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></div>
                <div className={`w-5 h-0.5 bg-[#0F2F3D] group-hover:bg-white transition-all duration-300 ${isMobileMenuOpen ? 'opacity-0' : ''}`}></div>
                <div className={`w-5 h-0.5 bg-[#0F2F3D] group-hover:bg-white transition-all duration-300 ${isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></div>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation - No Icons */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-white border-t border-[#F2F2F2] shadow-2xl">
            <div className="max-w-7xl mx-auto px-5 py-6">
              <div className="space-y-1">
                {currentNavItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`relative block px-5 py-4 rounded-xl font-medium transition-all duration-300 ${isActivePath(item.path)
                      ? 'text-white'
                      : 'text-[#333333] hover:pl-7'
                      }`}
                    style={isActivePath(item.path) ? { backgroundColor: '#0F2F3D' } : {}}
                  >
                    <span className="flex items-center justify-between">
                      <span className="text-base tracking-wide">{item.label}</span>
                      {item.badge > 0 && (
                        <span className="bg-[#E4572E] text-white text-xs font-bold rounded-full px-2.5 py-1.5 min-w-[28px] text-center shadow-lg">
                          {item.badge}
                        </span>
                      )}
                    </span>
                    {!isActivePath(item.path) && (
                      <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-[#E4572E] rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    )}
                  </Link>
                ))}

                {/* Mobile User Actions */}
                {isAuthenticated ? (
                  <div className="mt-8 pt-6 border-t-2 border-[#F2F2F2] space-y-4">
                    <div className="flex items-center space-x-4 px-5 py-4 bg-gradient-to-r from-[#F2F2F2] to-transparent rounded-2xl">
                      <div className="relative">
                        <div className="absolute inset-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] rounded-full blur-md"></div>
                        <div
                          className="relative w-14 h-14 rounded-full flex items-center justify-center text-white font-bold text-2xl shadow-2xl"
                          style={{ background: 'linear-gradient(135deg, #0F2F3D 0%, #E4572E 100%)' }}
                        >
                          {user?.name?.charAt(0)?.toUpperCase()}
                        </div>
                      </div>
                      <div>
                        <p className="text-lg font-bold" style={{ color: '#333333' }}>{user?.name}</p>
                        <p className="text-sm font-medium" style={{ color: '#E4572E' }}>{user?.rank || 'Premium Member'}</p>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        handleLogout();
                        setIsMobileMenuOpen(false);
                      }}
                      className="w-full px-5 py-4 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white rounded-xl hover:shadow-2xl transition-all duration-300 font-bold text-base tracking-wide"
                    >
                      Sign Out
                    </button>
                  </div>
                ) : (
                  <div className="mt-8 pt-6 border-t-2 border-[#F2F2F2] space-y-3">
                    <Link
                      to="/login"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block w-full px-5 py-4 border-2 border-[#0F2F3D] text-[#0F2F3D] rounded-xl hover:bg-[#0F2F3D] hover:text-white transition-all duration-300 text-center font-bold text-base tracking-wide"
                    >
                      Sign In
                    </Link>
                    <Link
                      to="/register"
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block w-full px-5 py-4 bg-[#0F2F3D] text-white rounded-xl hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 text-center font-bold text-base tracking-wide relative overflow-hidden group"
                    >
                      <span className="relative z-10">Join Free</span>
                      <span className="absolute inset-0 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;